module.exports = __webpack_public_path__ + "img/667.eb5bb4b3.jpg";